import { render } from "./LoginModelNew.vue?vue&type=template&id=55ee8b9d&scoped=true"
import script from "./LoginModelNew.vue?vue&type=script&lang=js"
export * from "./LoginModelNew.vue?vue&type=script&lang=js"

import "./LoginModelNew.vue?vue&type=style&index=0&id=55ee8b9d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src534590742/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ee8b9d"]])

export default __exports__